import {CesiumTerrainProvider, EllipsoidTerrainProvider, TerrainProvider} from 'cesium';
import {useEffect, useState} from 'react';
import {Scene} from 'resium';

import {useGlobus} from '../GlobusProvider';

export const TerrainScene = () => {
  const {terrainEnabled} = useGlobus();
  const [provider, setProvider] = useState<CesiumTerrainProvider | EllipsoidTerrainProvider | null>(null);

  useEffect(() => {
    const func = async () => {
      if (terrainEnabled) {
        try {
          TerrainProvider.heightmapTerrainQuality = 0.8;
          const terrain = await CesiumTerrainProvider.fromUrl('https://globusserver.de/cesiumterrain/terrain');
          setProvider(terrain);
        } catch (e) {
          console.warn('Falling back to EllipsoidTerrainProvider');
          setProvider(new EllipsoidTerrainProvider());
        }
      } else {
        setProvider(new EllipsoidTerrainProvider());
      }
    };
    func().catch(console.error);
  }, [terrainEnabled]);

  if (!provider) {
    return null;
  }

  return <Scene terrainProvider={provider}/>;
};
